import ChatFilledIcon from './ChatFilledIcon';
export default ChatFilledIcon;
